import { StyleSheet } from 'react-native';

export const colors = {
    background: '#FFFFFF',
    white: '#FFFFFF',
    black: '#000000',
    lightGrey: '#F0F0F0', // E6E9E9
    darkGray: '#999999',
    primary: '#607D8B', // FFCA36
    accent: '#',
    lightText: '#FEFEFE',
    darkText: '#141823', // 222222
    coloredText: '#FFCA36',
    urlText: '#6666ff',
    danger: '#E55B56',
    tag1: '#F44336',
    tag2: '#E91E63',
    tag3: '#4CAF50',
    tag4: '#2196F3',
    tag5: '#FFC107',
    tag6: '#FFEB3B',
    tag7: '#9C27B0',
    tag8: '#CDDC39',
    tag9: '#607D8B',
}

export const fonts = {
    light: 'OpenSans_300Light',
    regular: 'OpenSans_400Regular',
    semibold: 'OpenSans_600SemiBold',
    bold: 'OpenSans_700Bold',
    extraBold: 'OpenSans_800ExtraBold',
}
